import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { BasicDialog } from "ui/molecules/Dialog";

type Props = {
    readonly open: boolean;
    readonly pspName: string;
    readonly isProcessing?: boolean;
    readonly onConfirm: () => void;
    readonly onClose: () => void;
};

const DeleteKycDialog = ({
    open,
    pspName,
    isProcessing = false,
    onConfirm,
    onClose
}: Props) => (
    <BasicDialog
        isOpen={open}
        onClose={onClose}
        isCanClose={!isProcessing}
        actionsSlot={(
            <Stack direction='row' spacing={2}>
                <LoadingButton
                    variant='contained'
                    color='error'
                    loading={isProcessing}
                    onPointerDown={onConfirm}
                    data-test-id='pspKycSettings.delete.confirm'
                >
                    Delete KYC
                </LoadingButton>
                <Button
                    variant='outlined'
                    onPointerDown={onClose}
                    disabled={isProcessing}
                    data-test-id='pspKycSettings.delete.close'
                >
                    Close
                </Button>
            </Stack>
        )}
    >
        <Box sx={{ px: 2, py: 1 }}>
            <Typography
                variant='h6'
                sx={{ fontWeight: 700, textAlign: 'center' }}
            >
                Are you sure you want to delete the KYC settings for this PSP?
            </Typography>
            {pspName && (
                <Typography
                    variant='body1'
                    sx={{ mt: 2, textAlign: 'center' }}
                >
                    “{pspName}”
                </Typography>
            )}
        </Box>
    </BasicDialog>
);

export default memo(DeleteKycDialog);
